import { ErrorType } from "../../../types/errorType";

interface props {
  errorObject: ErrorType;
}

const errorColors = (errorType: string) => {
  if (errorType === "error") {
    return `text-red-500 bg-red-50`;
  } else if (errorType === "success") {
    return `text-green-500 bg-green-50`;
  }
};

const FormError = ({ errorObject }: props) => {
  return (
    <div
      className={`${errorColors(
        errorObject.errorType
      )} text-sm w-full text-center p-2 rounded-md`}
    >
      <p>{errorObject.errorMessage}</p>
    </div>
  );
};

export default FormError;
